import React, { useContext, useMemo } from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import { TFormValues, TStep, TStepComponents } from "../types";

import config from "../config";
import { GuideContext } from "../GatewayForm.store";

import FormikLocalStorageProvider from "./FormikLocalStorageProvider";

export const FormContextWrapper: React.FC<{}> = ({ children }) => {
  const { currentStep, currentConfig } = useContext(GuideContext);
  const initialValues: TFormValues = useMemo(() => {
    const allComponents: TStepComponents[] = Object.values(config.steps).reduce(
      (components: TStepComponents[], step: TStep) => {
        if (step.type === "content" || step.type === "form-content") {
          return components;
        }
        return [...components, ...step.components];
      },
      []
    );

    return allComponents.reduce((initalValues, component) => {
      return {
        ...initalValues,
        [component.name]: component.type === "checkbox" ? [] : "",
      };
    }, {});
  }, []);

  const validationSchema = useMemo(() => {
    const stepConfig = currentConfig.steps[currentStep];

    if (stepConfig === undefined || stepConfig.type === "content" || stepConfig.type === "form-content") {
      return Yup.object().shape({});
    }

    return Yup.object().shape(
      stepConfig.components.reduce((a, c) => {
        if (!c.validation) {
          return a;
        }
        return {
          ...a,
          [c.name]: c.validation,
        };
      }, {})
    );
  }, [currentConfig, currentStep]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => console.log(values)}
      >
        <FormikLocalStorageProvider>{children}</FormikLocalStorageProvider>
      </Formik>
    </>
  );
};

export default FormContextWrapper;
